var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"mc-form",class:[
    _vm.labelPosition ? 'mc-form--label-' + _vm.labelPosition : '',
    { 'mc-form--inline': _vm.inline }
  ]},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


// WEBPACK FOOTER //
// ./src/components/form.vue